<template>
    <div data-cy="container_home_default">
        <h1 data-cy="text_home_default_title">Template</h1>
    </div>
</template>
<script>
export default {
    name: "Default",
}
</script>
<style lang="scss" scoped>
    
</style>